import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarPlus } from 'lucide-react';
import MeetingForm from './MeetingForm';
import { useAuth } from '../context/AuthContext';

// "New meeting" button shown wherever meetings are relevant; opens the shared MeetingForm.
export const NewMeetingButton = ({ onSaved, className = '', size = 'md', testId = 'new-meeting-btn' }) => {
  const { canAccess, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  if (!(isAdmin || canAccess('admin-meetings'))) return null;
  const pad = size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2.5 text-sm';
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={testId}
        className={`inline-flex items-center gap-2 rounded font-title ${pad} ${className}`}
        style={{ background: 'var(--maroon)', color: 'var(--cream)' }}
      >
        <CalendarPlus size={size === 'sm' ? 14 : 16} /> New meeting
      </button>
      {open && (
        <MeetingForm
          meeting={null}
          onClose={() => setOpen(false)}
          onSaved={(m) => { setOpen(false); if (onSaved) onSaved(m); else if (m && m.id) navigate(`/meetings/${m.id}`); }}
        />
      )}
    </>
  );
};
